import { useState } from "react";
import { MainContainer } from "../components"

const DashBoard = () => {
   
   
    
    return (
        <MainContainer pageName="Dashboard" info={[]} breadcrumbs={["Home", "Dashboard"]}>
            <div>
                
            </div>
        </MainContainer>
    )
}
export default DashBoard